"use strict";

exports.__esModule = true;
exports["default"] = exports.StyledDot = exports.Dot = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _styles = require("@qc-modules/styles");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["active", "light"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Container = (0, _styledComponents["default"])(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, _extends({
    left: "50%",
    position: "absolute",
    top: "50%"
  }, props));
}).withConfig({
  displayName: "dots__Container",
  componentId: "sc-1d5bjtl-0"
})(["transform:translate(-50%,-50%);"]);
var StyledDot = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "dots__StyledDot",
  componentId: "sc-1d5bjtl-1"
})(["", ";"], (0, _styles.defaultTransition)("opacity", "background-color"));
exports.StyledDot = StyledDot;

var Dot = function Dot(_ref) {
  var active = _ref.active,
      light = _ref.light,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(StyledDot, _extends({
    backgroundColor: light ? "white" : "black",
    borderRadius: "50%",
    cursor: "pointer",
    display: "inline-block",
    height: "10px",
    mx: "5px",
    my: 0,
    opacity: active ? "0.3" : "0.1",
    width: "10px"
  }, props));
};

exports.Dot = Dot;
Dot.propTypes = {
  active: _propTypes.bool,
  light: _propTypes.string
};
var propTypes = {
  currentPage: _propTypes.number,
  // Function to render dots
  customDots: _propTypes.func,
  // Container component
  customDotsContainer: _propTypes.func,
  length: _propTypes.number,
  light: _propTypes.bool,
  onDotClick: _propTypes.func
};
var defaultProps = {
  customDotsContainer: Container,
  light: false
};

var Dots = function Dots(_ref2) {
  var DotsContainer = _ref2.customDotsContainer,
      CustomDots = _ref2.customDots,
      currentPage = _ref2.currentPage,
      light = _ref2.light,
      length = _ref2.length,
      onDotClick = _ref2.onDotClick;
  return /*#__PURE__*/_react["default"].createElement(DotsContainer, null, (0, _ramda.range)(0, length).map(function (i) {
    var dotProps = {
      active: currentPage === i,
      index: i,
      key: i,
      light: light,
      onClick: function onClick() {
        return onDotClick(i);
      }
    };
    return CustomDots ? /*#__PURE__*/_react["default"].createElement(CustomDots, dotProps) : /*#__PURE__*/_react["default"].createElement(Dot, dotProps);
  }));
};

Dots.defaultProps = defaultProps;
Dots.propTypes = propTypes;
var _default = Dots;
exports["default"] = _default;